<template>
  <div class="promotion-impressions">
    <slot/>
  </div>
</template>

<script>
export default {
  name: 'PromotionImpressions',
  data () {
    return {
      initialized: false,
      gtmPromotions: []
    }
  },
  methods: {
    registerPromotion (promotion) {
      this.gtmPromotions.push(promotion)
    },
    gtm () {
      if (!this.initialized) {
        this.initialized = true
        this.$store.dispatch('gtm/promotionImpressions', {
          promotions: this.gtmPromotions
        })
      }
    }
  },
  created () {
    this.$on('gtm:registration', this.registerPromotion)
  },
  watch: {
    gtmPromotions () {
      this.gtm()
    }
  }
}
</script>
